<template>
  <button
    :class="[$style.button, isActive && $style.active]"
    @click="handleClick"
    @mouseleave="handleMouseLeave"
  >
    {{ buttonTitle }}
  </button>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
export default defineComponent({
  name: 'ButtonPrimaryBigNeg',
  props: {
    buttonTitle: {
      type: String,
      default: 'Send'
    },
    property1: {
      type: String,
      default: 'default'
    }
  },
  emits: ['handleClick'],
  setup(props, { emit }) {
    const isActive = ref(false)
    const handleClick = () => {
      isActive.value = true
      emit('handleClick')
      setTimeout(() => {
        isActive.value = false
      }, 300)
    }

    const handleMouseLeave = () => {
      isActive.value = false
    }

    return {
      isActive,
      handleClick,
      handleMouseLeave
    }
  }
})
</script>

<style module>
.button {
  width: 100%;
  padding: 16px 24px;
  background-color: transparent;
  border: 3px solid var(--app-yellow);
  color: var(--app-yellow);
  font-family: 'TTSquares-Bold';
  font-size: 24px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 110%;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}

.button:hover {
  color: var(--app-black);
  background-color: var(--app-white);
  border: 3px solid transparent;
}

.button:disabled {
  /* background-color: rgba(0, 0, 0, 0.4); */
  color: var(--app-black);
  background-color: var(--app-white-diabled);
  border: 3px solid transparent;
  cursor: not-allowed;
}

.active {
  outline: 2px solid #0077b2;
}

@media (min-width: 768px) {
  .frame {
    font-size: 26px;
    padding: 16px 48px;
  }
}
</style>
